// Two-letter US state code → full state name. Used to spell out state
// names on the neighborhood directory + anywhere else the DB may have
// stored the abbreviation form. Case-insensitive, whitespace-tolerant.

export const US_STATE_ABBR_TO_NAME = {
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas",
  CA: "California", CO: "Colorado", CT: "Connecticut", DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida", GA: "Georgia", HI: "Hawaii", ID: "Idaho",
  IL: "Illinois", IN: "Indiana", IA: "Iowa", KS: "Kansas",
  KY: "Kentucky", LA: "Louisiana", ME: "Maine", MD: "Maryland",
  MA: "Massachusetts", MI: "Michigan", MN: "Minnesota", MS: "Mississippi",
  MO: "Missouri", MT: "Montana", NE: "Nebraska", NV: "Nevada",
  NH: "New Hampshire", NJ: "New Jersey", NM: "New Mexico", NY: "New York",
  NC: "North Carolina", ND: "North Dakota", OH: "Ohio", OK: "Oklahoma",
  OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island",
  SC: "South Carolina", SD: "South Dakota", TN: "Tennessee", TX: "Texas",
  UT: "Utah", VT: "Vermont", VA: "Virginia", WA: "Washington",
  WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming",
  // US territories — included so a business/customer that entered one
  // still renders a friendly name instead of a raw code.
  PR: "Puerto Rico", VI: "U.S. Virgin Islands", GU: "Guam",
  AS: "American Samoa", MP: "Northern Mariana Islands",
};

/**
 * Given a state string (either 2-letter code or already the full name),
 * return the full state name. Falls back to the input when we can't map it
 * (foreign countries, typos) — so nothing is ever "lost".
 */
export function expandStateName(raw) {
  if (!raw) return "";
  const s = String(raw).trim();
  if (!s) return "";
  // Already spelled out — return with title-casing to normalize any
  // "new york" or "CALIFORNIA" variants.
  if (s.length > 2) return titleCase(s);
  const code = s.toUpperCase();
  return US_STATE_ABBR_TO_NAME[code] || s;
}

function titleCase(str) {
  return str.replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.substr(1).toLowerCase());
}
